var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.outside,
          expression: "outside"
        }
      ],
      ref: "header",
      staticClass: "viva-navbar transparent fixed seo-page-nav",
      class: { "no-shadow": _vm.isIbeSticky }
    },
    [
      _vm.lang === "es"
        ? [
            _c("div", { staticClass: "body" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "menu-content" }, [
                _c(
                  "a",
                  {
                    staticClass: "check-in-mobile-btn",
                    attrs: { href: "https://www.vivaaerobus.com/mx/mi-vuelo/" }
                  },
                  [_vm._v("\n                    Mi vuelo\n                ")]
                ),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("nav", { staticClass: "user-links mobile-right" }, [
                  _c(
                    "a",
                    {
                      staticClass: "trigger-mobile",
                      on: {
                        click: function($event) {
                          return _vm.openMenuMobile()
                        }
                      }
                    },
                    [_c("span", { staticClass: "vi-menu-2" })]
                  ),
                  _vm._v(" "),
                  _vm._m(2)
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "viva-menu-mobile",
                class: { active: _vm.showMenuMobile },
                attrs: { id: "viva-header-vue" }
              },
              [
                _c("div", { staticClass: "head" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "back",
                      on: {
                        click: function($event) {
                          _vm.showMenuMobile = false
                        }
                      }
                    },
                    [_c("span", { staticClass: "vi-bold-cancel" })]
                  )
                ]),
                _vm._v(" "),
                _vm._m(4)
              ]
            )
          ]
        : [
            _c("div", { staticClass: "body" }, [
              _vm._m(5),
              _vm._v(" "),
              _c("div", { staticClass: "menu-content" }, [
                _c(
                  "a",
                  {
                    staticClass: "check-in-mobile-btn",
                    attrs: { href: "https://www.vivaaerobus.com/en/my-flight" }
                  },
                  [
                    _vm._v(
                      "\n                    Modify reservation\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _vm._m(6),
                _vm._v(" "),
                _c("nav", { staticClass: "user-links mobile-right" }, [
                  _c(
                    "a",
                    {
                      staticClass: "trigger-mobile",
                      on: {
                        click: function($event) {
                          return _vm.openMenuMobile()
                        }
                      }
                    },
                    [_c("span", { staticClass: "vi-menu-2" })]
                  ),
                  _vm._v(" "),
                  _vm._m(7)
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "viva-menu-mobile",
                class: { active: _vm.showMenuMobile },
                attrs: { id: "viva-header-vue" }
              },
              [
                _c("div", { staticClass: "head" }, [
                  _vm._m(8),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "back",
                      on: {
                        click: function($event) {
                          _vm.showMenuMobile = false
                        }
                      }
                    },
                    [_c("span", { staticClass: "vi-bold-cancel" })]
                  )
                ]),
                _vm._v(" "),
                _vm._m(9)
              ]
            )
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("a", { attrs: { href: "https://vivaaerobus.com/mx/" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("nav", { staticClass: "links mobile-right" }, [
      _c("ul", [
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href:
                  "https://www.vivaaerobus.com/mx/destinos/nuevas-rutas-para-ti"
              }
            },
            [_vm._v("Destinos")]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href:
                  "https://www.vivaaerobus.com/mx/promociones/promociones-de-vuelos"
              }
            },
            [_vm._v("Promociones")]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              attrs: { href: "https://www.apps.vivaaerobus.com/VivaMonitor/" }
            },
            [_vm._v("Estatus de vuelos")]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href: "https://www.vivaaerobus.com/mx/prepara-tu-vuelo/"
              }
            },
            [_vm._v("Prepárate para volar")]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            { attrs: { href: "https://www.vivaaerobus.com/mx/mi-vuelo-viva" } },
            [_vm._v("Mi vuelo")]
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [
        _c(
          "a",
          {
            staticClass: "important",
            attrs: { href: "https://www.vivaaerobus.com/mx/mi-vuelo/" }
          },
          [
            _vm._v(
              "\n                                Modifica tu reserva\n                            "
            )
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("a", { attrs: { href: "https://www.vivaaerobus.com/" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "body" }, [
      _c("ul", { staticClass: "menu" }, [
        _c("li", [
          _c("div", { staticClass: "container" }, [
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://www.vivaaerobus.com/mx/destinos/nuevas-rutas-para-ti"
                }
              },
              [
                _vm._v(
                  "\n                                Destinos\n                            "
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("div", { staticClass: "container" }, [
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://www.vivaaerobus.com/mx/promociones/promociones-de-vuelos"
                }
              },
              [
                _vm._v(
                  "\n                                Promociones\n                            "
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("div", { staticClass: "container" }, [
            _c(
              "a",
              { attrs: { href: "https://apps.vivaaerobus.com/VivaMonitor/" } },
              [
                _vm._v(
                  "\n                                Estatus de vuelos\n                            "
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("div", { staticClass: "container" }, [
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.vivaaerobus.com/mx/prepara-tu-vuelo/"
                }
              },
              [
                _vm._v(
                  "\n                                Prepárate para volar\n                            "
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("div", { staticClass: "container" }, [
            _c(
              "a",
              {
                attrs: { href: "https://www.vivaaerobus.com/mx/mi-vuelo-viva" }
              },
              [_vm._v("Modifica tu reserva")]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("a", { attrs: { href: "https://vivaaerobus.com/mx/" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("nav", { staticClass: "links mobile-right" }, [
      _c("ul", [
        _c("li", [
          _c(
            "a",
            { attrs: { href: "https://www.vivaaerobus.com/en/destinations" } },
            [_vm._v("Destinations")]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            { attrs: { href: "https://www.vivaaerobus.com/en/promotions" } },
            [_vm._v("Promotions")]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            { attrs: { href: "https://www.vivaaerobus.com/en/flight-status" } },
            [_vm._v("Flight Status")]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href: "https://www.vivaaerobus.com/en/prepare-your-flight"
              }
            },
            [_vm._v("Get ready to fly")]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              attrs: { href: "https://www.vivaaerobus.com/en/my-flight-viva" }
            },
            [_vm._v("My Flight")]
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [
        _c(
          "a",
          {
            staticClass: "important",
            attrs: { href: "https://www.vivaaerobus.com/en/my-flight" }
          },
          [
            _vm._v(
              "\n                                Modify reservation\n                            "
            )
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("a", { attrs: { href: "https://www.vivaaerobus.com/" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "body" }, [
      _c("ul", { staticClass: "menu" }, [
        _c("li", [
          _c("div", { staticClass: "container" }, [
            _c(
              "a",
              {
                attrs: { href: "https://www.vivaaerobus.com/en/destinations" }
              },
              [_vm._v("Destinations")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("div", { staticClass: "container" }, [
            _c(
              "a",
              { attrs: { href: "https://www.vivaaerobus.com/en/promotions" } },
              [
                _vm._v(
                  "\n                                Promotions\n                            "
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("div", { staticClass: "container" }, [
            _c(
              "a",
              {
                attrs: { href: "https://www.vivaaerobus.com/en/flight-status" }
              },
              [
                _vm._v(
                  "\n                                Flight Status\n                            "
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("div", { staticClass: "container" }, [
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.vivaaerobus.com/en/prepare-your-flight"
                }
              },
              [
                _vm._v(
                  "\n                                Get ready to fly\n                            "
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("div", { staticClass: "container" }, [
            _c(
              "a",
              {
                attrs: { href: "https://www.vivaaerobus.com/en/my-flight-viva" }
              },
              [
                _vm._v(
                  "\n                                My Flight\n                            "
                )
              ]
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }